import { AmplitudeEvent } from "./AmplitudeEvent";

/**
 * @note This refers to the quick edit method of updating
 */
export class GoalConfidenceUpdatedEvent extends AmplitudeEvent {
	constructor( teamName ) {
		super();
		this.name = "Goal Confidence Updated";
		this.eventProperties.team_name = teamName;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/GoalConfidenceUpdatedEvent.js